import { registerTTAPPlugin, reportCustomRequest, getContainerInitTotalTime, reportFirstScreenRequest, reportActualFMP, slardarWeb, webapp, inapp, reportRenderEnd, reportRenderStart } from "@byted-tiktok/ttap-slardarweb-plugin";
class TtapPlugin {
  onConnect(ev) {
    const ttapFuncs = {
      reportCustomRequest: (requestName, startTime, endTime) => reportCustomRequest(requestName, startTime, endTime, this.slardarClient),
      getContainerInitTotalTime,
      reportFirstScreenRequest: (startTimestamp, endTimestamp) => reportFirstScreenRequest(startTimestamp, endTimestamp, this.slardarClient),
      reportActualFMP: () => reportActualFMP(this.slardarClient),
      reportActualLCP: () => reportActualFMP(this.slardarClient),
      reportRenderStart: () => reportRenderStart(this.slardarClient),
      reportRenderEnd: () => reportRenderEnd(this.slardarClient)
    };
    ev.data("ttap", ttapFuncs);
    ev.data("reportActualLCP", ttapFuncs.reportActualFMP);
    ev.data("reportCustomRequest", ttapFuncs.reportCustomRequest);
    ev.data("getContainerInitTotalTime", ttapFuncs.getContainerInitTotalTime);
    ev.data("reportFirstScreenRequest", ttapFuncs.reportFirstScreenRequest);
    ev.data("reportRenderStart", ttapFuncs.reportRenderStart);
    ev.data("reportRenderEnd", ttapFuncs.reportRenderEnd);
  }
  onInit({ container, data }) {
    const { ttap } = data;
    const slardar = slardarWeb(() => container.rawInstance());
    this.slardarClient = slardar;
    return registerTTAPPlugin({
      slardar,
      scenario: ttap?.jsb ? inapp(ttap.jsb) : webapp(),
      ...ttap
    });
  }
  // calling while Slardar.create for creating a new slardar instance
  // if there is no onCreate, the plugin will not copy to new instance
  onCreate() {
    return new TtapPlugin();
  }
  constructor() {
    this.name = "ttap_plugin";
    this.slardarClient = void 0;
  }
}
export {
  TtapPlugin
};

//# sourceMappingURL=ttap.js.map